export default __webpack_public_path__ + "static/media/banner.f48bd695.png";